const officesListing = ($) => {
  let is_country_specific = window.ddb.api.offices.is_country_specific || false;
  let apiURL = window.ddb.api.offices.apiUrl
  let region = window.ddb.api.offices.region
  let country = window.ddb.api.offices.country
  let selected_offices = window.ddb.api.offices.selected_offices
  let countryName = ''
  let regions_list = window.ddb.api.offices.regions
  let coutries_list = [];
  let regions;

  const STATE = {
    NOT_CHOOSE: 0,
    REGION: 1,
    COUNTRY: 2
  }
  let pathName = '';
  let select_state = STATE.NOT_CHOOSE;

  function setPathName() {
    pathName = window.location.pathname;
  }

  listingData();

  $(window).on('popstate', function (e) {
    console.log(pathName)
    if (!isPathNameChange())
      return;
    setPathName();

    checkStateOnUrl();
    
    if (select_state === STATE.COUNTRY) {
      coutries_list.forEach((item) => {
        if (country == item.value) {
          countryName = item.name;
        }
      })
      $('#country').html(countryName)
      setCountryParams(region, country)
      setOfficesList();
    } else {
      listingData();
    }
  });

  function isPathNameChange() {
    return pathName != window.location.pathname;
  }

  function listingData() {       
    if( is_country_specific == true) {
      $('#region-filter').hide();      
      $('#title-filter').hide();  
      let $parent = $('#title-filter').parent();      
      $parent.attr('style', 'margin-bottom: 0 !important');     
      setOfficesList();
    } else {
      getRegions(apiURL).then(res => {        
        regions = process_region_list(res)
        if (regions.indexOf(region) >= 0) {
          let regionOption = document.getElementById(region)
          setCountriesList(regionOption);
        } else {
          history.pushState(null, '', '/offices/');
          setPathName();
        }
      })
    }    
  }

  function checkStateOnUrl() {
    var pathArray = window.location.pathname.split('/');

    if (pathArray.length < 3) {
      select_state = STATE.NOT_CHOOSE;
      region = '';
      country = '';
      return;
    }

    if (pathArray[1] != 'offices') {
      return;
    }

    if (pathArray.length === 3) {
      select_state = STATE.REGION;
      region = pathArray[2];
      country = '';
      return;
    }

    if (pathArray.length === 4) {
      select_state = STATE.COUNTRY;
      region = pathArray[2];
      country = pathArray[3];
    }

  }

  function setRegionParams(region) {
    history.pushState(null, '', '/offices/' + region);
    setPathName();
  }

  function setCountryParams(region, country) {
    history.pushState(null, '', window.location.origin + '/offices/' + region + '/' + country);
    setPathName();
  }

  function process_country_list(res, region) {
    let data = [];
    res.forEach((val) => {
      if (val.slug == region) {
        if (val.countries != undefined) {
          val.countries.forEach((country) => {
            data.push({
              name: country.name,
              value: country.slug
            })
          })
        }
      }
    })

    coutries_list = data;
    return data;
  }

  function process_region_list(res) {
    let data = [];
    res.forEach((region) => {
      data.push(region.slug)
    })
    return data;
  }

  function process_offices_list(res, region, countryName) {        
    let data = [];
    
    res.forEach((val) => {
      
      if (val.slug == region) {
        if (val.countries != undefined) {
          val.countries.forEach((country) => {
            
            if (selected_offices.length > 0) {                            
              
              selected_offices.map(function (office_slug) {
                
                if (country.slug == countryName && country.offices != undefined) {
                  country.offices.forEach((office) => {
                    if ( office.slug == office_slug) {
                      data.push(office);
                    }                  
                  })
                }
              });
            } else {
              if (country.slug == countryName && country.offices != undefined) {
                country.offices.forEach((office) => {
                  data.push(office)
                })
              }
            }

          })
        }
      }
    })

    return data;
  }

  function convert_offices_to_array(countries) {
    data = [];
    countries = Object.values(countries.countries)
    countries.forEach((country) => {
      country.offices = Object.values(country.offices)

      country.offices.forEach((office) => {
        data.push(office)
      })
    })
    return data;
  }

  function process_offices_seach_list(res) {
    let data = [];
    let regions_data = Object.keys(regions_list);

    if (res.results == 0)
      return data;

    if (regions_data.length > 0) {
      regions_data.forEach(value => {
        if (res[value] != undefined) {
          data.push(...convert_offices_to_array(res[value]))
        }
      })
    }

    return data;
  }

  async function getRegions($url) {
    const response = await axios.get($url);
    return response.data
  }

  async function getCountries($url) {
    const response = await axios.get($url);
    return response.data
  }

  async function getOffices($url) {
    const response = await axios.get($url);
    return response.data
  }

  async function searchOffices($url, $query) {
    const response = await axios.get($url + '?s=' + $query);
    return response.data
  }

  function setCountryLoading() {
    $('#countries > .scroll-content').html('');
    $('#country').html('Loading...');
    $('#offices-list').html('');
  }

  function setCountriesList(element) {
    setCountryLoading();
    $('#country-filter').show();

    region = $(element).attr('id')
    let regionName = $(element).html()
    console.log(regionName)
    $('#region').html(regionName)

    setRegionParams(region)

    let countries;
    getCountries(apiURL + region).then(res => {
      countries = process_country_list(res, region)
      if (countries.length > 0) {
        $('#country').html('Country');
        $('#offices-list').html('')

        let isCountryExist = false;
        countries.forEach((item) => {
          let html = ` <div class="option" id="${item.value}" data-cursor="disabled">${item.name}</div>`
          $('#countries > .scroll-content').append(html);
          if (country == item.value) {
            isCountryExist = true;
            countryName = item.name;
          }
        })
        if (isCountryExist) {
          $('#country').html(countryName)
          setCountryParams(region, country)
          setOfficesList();
        }


        $('#countries > .scroll-content').click((e) => {
          country = $(e.target).attr('id')
          countryName = $(e.target).html()
          $('#country').html(countryName)
          setCountryParams(region, country)
          setOfficesList();
        })
      }
    })
  }

  function setOfficesList() {
    $('#offices-list').html('');

    $('.loading').html(`
      <div class="spinner"></div>
    `);


    getOffices(apiURL + region + '/' + country).then(res => {
      const offices = process_offices_list(res, region, country)
      let mql = window.matchMedia('(min-width: 768px)');
      if ($('.card-container__inner').get(0).slick && $('.card-container__inner').get(0).slick.unslicked == false) {
        $('.card-container__inner').slick('unslick');
        $('#offices-list').html('');
      }

      $('.loading').html('')

      if (offices.length > 0) {
        offices.forEach((office) => {
          let websiteUrl = office.details[0].website;
          websiteUrl = ( websiteUrl && websiteUrl.indexOf('http') == -1 ) ? 'http://'+websiteUrl : websiteUrl;
          const tel = (office.details[0].main_phone) ? `<div class='address__tel'>Tel. <span>${office.details[0].main_phone}</span></div>` : '';
          const fax = (office.details[0].main_fax) ? `<div class='address__fax'>Fax. <span>${office.details[0].main_fax}</span></div>` : '';
          const link = (websiteUrl) ? `<a href="${websiteUrl}" title="${office.details[0].website}" target="_blank">${office.details[0].website}</a>` : '';

          let html = `
            <li class='card-container__item'>
              <div class='card card--office'>
                <div class='card__image'>
                  <figure class='card__image image is-square'>
                    <div style='background-image: url(${office.thumbnail})' class='image-cover'></div>
                  </figure>
                  <div class='card__content'>
                    <address>
                      <div class='address__title'>${office.name}</div>
                      <div class='address__city'>${office.city}</div>
                      <div class='address__addr'>${office.details[0].address}</div>
                      ${tel}
                      ${fax}
                    </address>
                  </div>
                  <footer class='card__footer card__footer--links'>
                      ${link}
                  </footer>
                </div>
              </div>
            </li>
          `
          $('#offices-list').append(html);
          window.ddb.utils.triggerResize();
        })

        if (mql.matches === false) {
          $('.card-container__inner').slick({
            dots: false,
            infinite: false,
            speed: 500,
            useTransform: true,
            variableWidth: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            autoplay: false,
            arrows: false,
          });
        }

      }
    }).then(() => {
      setTimeout(() => {
        $('.card-container__item').matchHeight();
      }, 1000)
    })
  }

  $('#regions > .scroll-content > .option').click((e) => {
    country = '';
    setCountriesList(e.target)
  })

  $('#search-office').keyup((e) => {
    let query = e.target.value;
    $('#offices-list-search > .scroll-content').html('');

    if (query.length >= 3) {
      $('#offices-list-search > .scroll-content').html(`
        <div class="spinner"></div>
      `);

      searchOffices(apiURL, query).then(res => {
        const offices = process_offices_seach_list(res, region, country)
        $('#offices-list-search > .scroll-content').html('');
        if (offices.length > 0) {
          offices.forEach((office) => {
            let html = `
              <div class="option">
                <address>
                  <div class='address__title'>${office.name}</div>
                  <div class='address__addr'>${office.address}</div>
                  <div class='address__tel'>${office.main_fax !== '' ? 'Tel.' : ''} <span>${office.main_phone}</span></div>
                  <div class='address__fax'>${office.main_fax !== '' ? 'Fax.' : ''}<span>${office.main_fax}</span></div>
                </address>
              </div>
            `
            $('#offices-list-search .scroll-content').append(html);
          })
        } else {
          $('#offices-list-search .scroll-content').html('<span>No result(s) found.</span>');
        }
      })
    }
  })

};

module.exports = officesListing;
